// Time formatting in the product voice: short, plain, never "a few moments ago".

export function clock(at: number): string {
  const d = new Date(at);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** "just now", "40 s", "3 min", "2 h", "yesterday 14:32", "12 Oct". */
export function ago(at: number, now: number): string {
  const diff = Math.max(0, now - at);
  if (diff < 10_000) return "just now";
  if (diff < 60_000) return `${Math.floor(diff / 1000)} s`;
  if (diff < 60 * 60_000) return `${Math.floor(diff / 60_000)} min`;
  if (diff < 24 * 60 * 60_000) return `${Math.floor(diff / 3_600_000)} h`;
  const d = new Date(at);
  const n = new Date(now);
  const yesterday = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `yesterday ${clock(at)}`;
  return `${d.getDate()} ${d.toLocaleString("en", { month: "short" })}`;
}

/** "waiting 3 min" style duration: "40 s", "3 min", "1 h 12 min". */
export function duration(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  return rem ? `${h} h ${rem} min` : `${h} h`;
}

/** "9:40" countdown for holds (SPEC 7.3 "Held for the phone"). */
export function countdown(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** "for 2 hours", "until 18:00" for alert modes with a duration. */
export function untilText(until: number | undefined, now: number): string {
  if (!until) return "";
  const left = until - now;
  if (left <= 0) return "";
  if (left < 50 * 60_000) return `for ${Math.max(1, Math.round(left / 60_000))} min`;
  if (left < 12 * 3_600_000) {
    const h = Math.round(left / 3_600_000);
    return `for ${h} hour${h === 1 ? "" : "s"}`;
  }
  return `until ${clock(until)}`;
}
